import { Pipe, PipeTransform } from '@angular/core';
import isNil from 'lodash/isNil';
import { FUEL_ECONOMY_UNIT } from '../services/company.interface';

const OFFSET: number = 2.35215;

@Pipe({ name: 'fuelEconomy' })
export class FuelEconomyPipe implements PipeTransform {
  public transform(economy: number, userMetricUnits: boolean, currentDataUnits: string, decimalPlaces: number = 1): number {
    if (isNil(economy)) return null;

    if (userMetricUnits) {
      if (currentDataUnits.toLowerCase() === 'km/l' || currentDataUnits === FUEL_ECONOMY_UNIT.KM_PER_LITRE) {
        return parseFloat(economy.toFixed(decimalPlaces));
      }
      else if (currentDataUnits.toLowerCase() === 'l/100km' || currentDataUnits === FUEL_ECONOMY_UNIT.LITRE_PER_HUNDRED_KM) {
        return economy ? parseFloat((100 / economy).toFixed(decimalPlaces)) : 0;
      } else return parseFloat((economy / OFFSET).toFixed(decimalPlaces));
    } else {
      return parseFloat((economy * OFFSET).toFixed(decimalPlaces));
    }
  }
}
